import { Component, Input, OnInit } from '@angular/core';
import { IBallotSearchResult } from '../shared/models/search/ballot-search-result';
import { materialSymbols } from '../../../shared/constants/material-symbols';

@Component({
    selector: 'app-user-has-voted',
    templateUrl: './user-has-voted.component.html',
    styleUrl: './user-has-voted.component.scss',
    standalone: false
})
export class UserHasVotedComponent implements OnInit{
  @Input() ballot!: IBallotSearchResult;
  userHasVoted: boolean | null = null;
  checkSymbol = materialSymbols.check;
 
  ngOnInit(): void {
      
    this.userHasVoted = this.hasUserVoted(this.ballot);
  }

  hasUserVoted(ballot: IBallotSearchResult): boolean | null {
    if (!ballot || !ballot.isCurrentUserEligibleVoter) {
      return null;
    }

    return ballot.hasCurrentUserVoted;
  }
}
